export default class Submenu {

    constructor() {
        if (this.submenu = document.querySelector(".submenu")) {
            this.submenuTrigger = document.querySelector(".submenu-trigger")
            this._toggleSubmenu()
        }

        // expand the submenu-item to show the sub-level items
        if (this.submenuSubToggle = document.querySelectorAll(".submenu-sub-toggle"))
            this._expandSubmenu()
    }

    _toggleSubmenu() {
        this.submenuTrigger.addEventListener("click", (e) => {
            if (e.target === this.submenuTrigger) {
                this.submenu.classList.toggle("submenu--active")
            }
        })
    }

    _expandSubmenu() {
        for(let i = 0, l = this.submenuSubToggle.length; i < l; i++) {
            this.submenuSubToggle[i].addEventListener("click", (e) => {
                e.currentTarget.parentElement.classList.toggle("submenu-item--open")
            })
        }
    }
}